import Radium from '@flipdish/radium';
import axios from 'axios';
import * as Raven from 'raven-js';
import * as React from 'react';
import { Form, FormControl, FormGroup } from 'react-bootstrap';
import { findDOMNode } from 'react-dom';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Link } from 'react-router';
import { Icon, PageTitle, SectionHeader, SectionHeaderIcon, SectionHeaderText } from '../../../ui';
import { Track } from '../../analytics';
import * as Api from '../../Api';
import * as Data from '../../Data';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import RememberMe from '../../../ui/RememberMe/RememberMe';
import * as cookieConsentActions from '../../redux/cookie-consent/actions';
import * as selectors from '../../selectors/cookieSelector';
import { MainLayout } from '../MainLayout/MainLayout';
import { Hidden } from '@material-ui/core';
import { FixedBottomContainer } from '../FixedBottomContainer/FixedBottomContainer';

const tinycolor = require('tinycolor2');

interface RouteParams {
  params: {
    dlid?: number;
  };
}

interface StateProps {
  LastRestaurantUrl: string;
  AppConfig: Data.Async<Api.AppConfig>;
  PhoneNumberConfig: Api.PhoneNumberConfig;
  translate: any;
  AppDesignScheme: Api.AppDesignScheme;
  isDark: boolean;
  rememberMe: boolean;
  enableRememberMe: boolean;
}

type Props = StateProps & RouteParams & MappedDispatch;

interface State {
  PhoneNumber: string;
}

class PhoneNumber extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);
    this.state = {
      PhoneNumber: props.PhoneNumberConfig ? props.PhoneNumberConfig.Prefix : '+1'
    };
  }

  public async componentDidMount() {
    const domNode = findDOMNode(this);
    if (domNode) {
      Utilities.ensureVisible(domNode);
    }
  }

  // Computer the URL for entering the SMS code on.
  private codeUrl = (): string => {
    let base = '/code/' + this.state.PhoneNumber;

    if (this.props.params.dlid) {
      base += '/' + this.props.params.dlid;
    }

    return base;
  };

  private handlePhoneNumberSubmit = () => {
    const ifSubmitFails = (error: any) => {
      const { AppConfig } = this.props;

      let appconfig: any = {};

      if (AppConfig.status === 'success') {
        appconfig.AppNameId = AppConfig.data.AppNameId;
        appconfig.WhiteLabelId = AppConfig.data.WhiteLabelId;
      }

      // TODO - message the user about the failure reason.
      Raven.captureMessage('Submit phone number failed', {
        tags: { category: 'API failure' },
        extra: {
          error: Utilities.handleError(error),
          appconfig: appconfig,
          phone: this.state.PhoneNumber
        }
      });
    };

    const commonHeaders = { ...axios.defaults.headers.common };

    delete commonHeaders['X-Flipdish-Token'];

    const xhr = axios.post(
      '/Account/RequestPhoneLoginCodeSms',
      {
        DeviceName: window.navigator.userAgent,
        PhoneNumber: this.state.PhoneNumber
      },
      {
        withCredentials: false,
        headers: {
          common: commonHeaders
        }
      }
    );

    xhr.then((e) => {
      const r: Api.Result<any> = e.data;

      if (!r.Success) {
        alert(r.UserMessage);
        ifSubmitFails(r);
      } else {
        //@ts-ignore
        this.props.router.push(this.codeUrl());
      }
    });

    xhr.catch(ifSubmitFails);

    Track('Login', 'Submit Phone Number Button');
  };

  private handlePhoneNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const pn = event.target.value.replace(/\s/g, '');

    const hasPlusPrefix = pn && pn.charAt(0) && pn.charAt(0) == '+';
    const newPn = (hasPlusPrefix ? '+' : '') + pn.replace(/\D/g, '');

    const isNumber = newPn.match(/^\+?\d*$/);

    if (!isNumber) {
      return;
    }

    this.setState(
      {
        PhoneNumber: newPn
      },
      () => {
        const { AutocompletePhoneNumberLength, Prefix } = this.props.PhoneNumberConfig || {
          AutocompletePhoneNumberLength: 12,
          Prefix: '+1'
        };
        if (
          pn.length == AutocompletePhoneNumberLength &&
          pn.startsWith(Prefix) &&
          // disable auto-submit if phone # start w '+'
          !hasPlusPrefix
        ) {
          this.handlePhoneNumberSubmit();
        }
      }
    );
  };

  private phoneNumberKeyPress = (target: React.KeyboardEvent<HTMLInputElement>) => {
    return;
    // Handle Enter
    /*if (target.charCode == 13) {
      this.handlePhoneNumberSubmit();
    }*/
  };

  private phoneNumberValidation = (): Data.ValidationState => {
    const { AutocompletePhoneNumberLength, Prefix } = this.props.PhoneNumberConfig || {
      AutocompletePhoneNumberLength: 12,
      Prefix: '+1'
    };
    const { PhoneNumber } = this.state;

    if (PhoneNumber.length < AutocompletePhoneNumberLength) {
      return undefined;
    }

    if (
      Utilities.startsWith(PhoneNumber, Prefix) &&
      PhoneNumber.length == AutocompletePhoneNumberLength
    ) {
      return 'success';
    }

    return 'warning';
  };

  private termsOfService = (): JSX.Element | null => {
    const { AppConfig, AppDesignScheme, isDark, translate } = this.props;
    const styles = {
      secondary: {
        color: AppDesignScheme.Secondary
      },
      lightTerms: {
        color: AppDesignScheme.Tertiary,
        background: AppDesignScheme.Primary
      },
      darkTerms: {
        color: AppDesignScheme.Primary,
        background: AppDesignScheme.Tertiary
      }
    };

    if (AppConfig.status !== 'success') {
      return null;
    }

    const termsAndConditionsLinks = [
      { key: 'Terms_and_conditions', LinkUrl: AppConfig.data.TermsAndConditionsUrl },
      { key: 'Privacy_policy', LinkUrl: AppConfig.data.PrivacyPolicyUrl }
    ].map((item) => (
      <a href={item.LinkUrl} target="_blank" style={styles.secondary} key={item.key}>
        {translate(item.key)}
      </a>
    ));

    return (
      <p
        // this style conflicts with footer logic!
        // className={`tertiary text-center phone__terms fd-h5 ${
        //   Utilities.isIOS || Utilities.extraOption('data-full-screen-on-mobile') === 'false'
        //     ? 'phone__terms--ios'
        //     : ''
        // }`}
        className={`tertiary text-center phone__terms`}
        style={isDark ? styles.darkTerms : styles.lightTerms}
      >
        {translate('Enter_phone_number_terms_message')
          .split('%@')
          .reduce((acc, subString, index) => {
            acc.push(subString);
            if (index < termsAndConditionsLinks.length) {
              acc.push(termsAndConditionsLinks[index]);
            }
            return acc;
          }, [])}
      </p>
    );
  };

  public render(): JSX.Element {
    const {
      translate,
      AppDesignScheme,
      isDark,
      rememberMe,
      setRememberMe,
      enableRememberMe
    } = this.props;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      subheader: {
        borderColor: AppDesignScheme.Secondary,
        boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        backgroundColor: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString()
      },
      darkSubheader: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString(),
        backgroundColor: tinycolor(AppDesignScheme.Tertiary)
          .lighten(10)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary).darken(10)}`
      },
      nav: {
        ':hover': {},
        ':active': {}
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      secondaryHover: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      },
      buttonSecondary: {
        backgroundColor: AppDesignScheme.Secondary,
        ':hover': {},
        ':active': {},
        ':focus': {}
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      buttonHover: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      },
      formControl: {
        color: AppDesignScheme.Tertiary,
        background: AppDesignScheme.Primary,
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .setAlpha(0.2)
          .toString(),
        ':focus': {
          borderColor: AppDesignScheme.Secondary
        }
      },
      darkFormControl: {
        color: AppDesignScheme.Primary,
        background: AppDesignScheme.Tertiary,
        borderColor: AppDesignScheme.Primary
      }
    };

    return (
      <MainLayout xsPaddingBottom="60px" smPaddingBottom="60px">
        <div className="container-fluid flex flex-column">
          <div className="container phone flex-one xs-full-width">
            <div className="row">
              <div className="col-md-12">
                <div style={{ marginTop: '20px' }} />

                <PageTitle>{translate('Login')}</PageTitle>

                <Link to={this.props.LastRestaurantUrl} data-fd="phone-back">
                  <div
                    key="fd-nav"
                    className="fd-nav flex flex-align-center"
                    style={styles.nav as any}
                  >
                    <i
                      className="arrow_carrot-left tertiary"
                      aria-hidden="true"
                      style={
                        Radium.getState(this.state, 'fd-nav', ':active')
                          ? styles.secondaryActive
                          : Radium.getState(this.state, 'fd-nav', ':hover')
                          ? styles.secondaryHover
                          : isDark
                          ? styles.primary
                          : styles.tertiary
                      }
                    />
                    <p
                      className="inline-block clear-margins tertiary bold"
                      style={
                        Radium.getState(this.state, 'fd-nav', ':active')
                          ? styles.secondaryActive
                          : Radium.getState(this.state, 'fd-nav', ':hover')
                          ? styles.secondaryHover
                          : isDark
                          ? styles.primary
                          : styles.tertiary
                      }
                    >
                      <u>{translate('Back')}</u>
                    </p>
                  </div>
                </Link>

                <SectionHeader>
                  <SectionHeaderIcon>
                    <Icon fontSize="large" aria-hidden color="inherit" className="ei icon_mobile" />
                  </SectionHeaderIcon>

                  <SectionHeaderText title={translate('Enter_your_mobile_number')} />
                </SectionHeader>

                <div className="tertiary" style={isDark ? styles.primary : styles.tertiary}>
                  <p className="fd-h4">{translate('Mobile_verification')}</p>
                </div>
                <Form
                  onSubmit={(event) => {
                    event.preventDefault();
                  }}
                >
                  <FormGroup validationState={this.phoneNumberValidation()}>
                    <input
                      aria-label={`${translate('Enter_your_mobile_number')}  ${translate(
                        'Mobile_verification'
                      )}`}
                      type="tel"
                      id="phoneInput"
                      inputMode="tel"
                      autoFocus={true}
                      onKeyPress={this.phoneNumberKeyPress}
                      onChange={this.handlePhoneNumberChange}
                      onFocus={() => {
                        const phoneInput: any = document.getElementById('phoneInput');
                        if (phoneInput) {
                          const temp_value = phoneInput.value;
                          phoneInput.value = '';
                          phoneInput.value = temp_value;
                        }
                      }}
                      value={this.state.PhoneNumber}
                      className="form-control"
                      placeholder={'e.g. +44775555555'}
                      style={isDark ? styles.darkFormControl : styles.formControl}
                      key="phoneInput"
                      data-fd="phone-input"
                    />
                    <FormControl.Feedback />

                    {enableRememberMe && (
                      <RememberMe
                        checked={rememberMe}
                        onChange={setRememberMe}
                        isDark={isDark}
                        AppDesignScheme={AppDesignScheme}
                      />
                    )}
                  </FormGroup>
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <Hidden only={['xs', 'sm']}>
                        <button
                          className="fd-button fd-button--big fd-button--secondary"
                          onClick={this.handlePhoneNumberSubmit}
                          key="submit-button"
                          style={
                            [
                              styles.buttonSecondary,
                              Radium.getState(this.state, 'submit-button', ':active')
                                ? styles.buttonActive
                                : Radium.getState(this.state, 'submit-button', ':hover')
                                ? styles.buttonHover
                                : null
                            ] as any
                          }
                          data-fd="phone-submit"
                        >
                          <p className="clear-margins primary fd-h4" style={styles.primary}>
                            {translate('Next')}
                          </p>
                        </button>
                      </Hidden>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div>{this.termsOfService()}</div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          <div className="row">
            <FixedBottomContainer fixedOnly={['xs', 'sm']}>
              <Hidden mdUp>
                <button
                  className={`fd-button fd-button--bottom fd-button--secondary ${
                    Utilities.isIOS ||
                    Utilities.extraOption('data-full-screen-on-mobile') === 'false'
                      ? 'fd-button--bottom-ios'
                      : ''
                  }`}
                  onClick={this.handlePhoneNumberSubmit}
                  key="submit-button-bottom"
                  style={
                    [
                      styles.buttonSecondary,
                      Radium.getState(this.state, 'submit-button-bottom', ':active')
                        ? styles.buttonActive
                        : Radium.getState(this.state, 'submit-button-bottom', ':hover')
                        ? styles.buttonHover
                        : null
                    ] as any
                  }
                  data-fd="phone-submit-bottom"
                >
                  <p className="clear-margins primary" style={styles.primary}>
                    {translate('Next')}
                  </p>
                </button>
              </Hidden>
            </FixedBottomContainer>
          </div>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state: Store.State): StateProps => {
  const {
    flipdish: { LastRestaurantUrl, AppConfig, PhoneNumberConfig, isDark },
    appDesignScheme,
    cookieConsent
  } = state;
  return {
    LastRestaurantUrl,
    AppConfig,
    PhoneNumberConfig,
    AppDesignScheme: appDesignScheme,
    translate: getTranslate(state.locale),
    isDark: isDark,
    rememberMe: cookieConsent.rememberMe,
    enableRememberMe: selectors.enableRememberMe(state)
  };
};

type MappedDispatch = ReturnType<typeof mapDispatchToProps>;
const mapDispatchToProps = (dispatch: ThunkDispatch<Store.State, {}, Action>) => ({
  setRememberMe: (value: boolean) => dispatch(cookieConsentActions.setRememberMe(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(Radium(PhoneNumber));
